var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.fullversion)?_c('haze-full',{on:{"toggle-version":_vm.toggleVersion}}):_c('haze-short',{on:{"toggle-version":_vm.toggleVersion}})}
var staticRenderFns = []

export { render, staticRenderFns }